export const CREATED_MUTING = "CREATED_MUTING";
export const DELETED_MUTING = "CHANGED_MUTING";
export const RECEIVED_MUTING = "RECEIVED_MUTING";
export const FETCHED_MUTING = "FETCHED_MUTING";
